import { gql, TypedDocumentNode } from "@apollo/client";
import { StudentInternshipsQuery, StudentInternshipsQueryVariables } from "./types";

export const STUDENT_INTERNSHIPS_QUERY: TypedDocumentNode<StudentInternshipsQuery, StudentInternshipsQueryVariables> =
  gql`
    query studentInternships($input: BackofficeEducationStudentInternshipsInput!, $first: Int, $after: String) {
      studentInternships(input: $input, first: $first, after: $after) {
        totalCount
        edges {
          node {
            id
            title
            jobClassification
            startedOn
            endedOn
            workingLocation
            isPrimary
            description
            internshipCredits
            durationMonths
            isActive
            internshipType
            universitySectionName
            employmentSectionName
            student {
              id
              firstName
              lastName
              displayName
              profilePhoto
              pgaId
              email
              phoneNumbers {
                id
                phoneNumber
                phoneType
                phoneFormatted
              }
            }
            facility {
              id
              name
              facilityType
              mainAddress {
                state
              }
              section {
                id
                name
              }
            }
            facilitySection {
              id
              name
              legacyId
            }
            studentPgmLevel
            studentCurriculumVersion
            studentEligibleForGraduation
            supervisor {
              id
              firstName
              lastName
              pgaId
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  `;
